import React from "react";
import Section from "../../components/section/Section";
import AppointmentTypesSection from "./components/appointment-types-section/AppointmentTypesSection";
import CalendarSection from "./components/calendar-section/CalendarSection";
import SchedulingWindowsSection from "./components/scheduling-windows-section/SchedulingWindowsSection";
import { useSelector } from "react-redux";

export const CALENDAR_MANAGEMENT = "calendar-management";
const CalendarManagement = () => {
  const { productName } = useSelector((state) => state.info.organization);

  return (
    <Section
      title="Appointment Scheduling"
      subtitle={`Define the service appointments you'd like the ${productName} to offer to your customers.`}
      content={
        <div className="flex flex-col gap-8">
          <CalendarSection />
          <SchedulingWindowsSection />
          <AppointmentTypesSection />
        </div>
      }
      overrideStyle={{}}
    />
  );
};

export default CalendarManagement;
